module.exports = __webpack_public_path__ + "img/report_bg_advice_d.82c293db.png";